<template>
  <body>
    <Header></Header>

    <div class="container">
      <img src="top20_logo.png" height="50px" width="50px" class="logo" />
      <div class="title">Producing VS User</div>
      <div class="Intro_container">
        <div class="Intro">Thinking: Netflix's Feture Development</div>
        <div class="split"></div>

        <div class="legend">
          <div style="color: brown; font-size: 17px">
            ------Red: Total producing number
          </div>
          <div style="color: orange; font-size: 17px">
            ------Orange: Total users
          </div>
        </div>
      </div>

      <div>
        <svg id="chart" style="margin-top: 30px; margin-left: 50px"></svg>
      </div>
      <router-link to="/map" @click.native="scrollToTop">
        <div class="next">
          <img src="next.png" height="50px" width="50px" />
        </div>
      </router-link>
    </div>
  </body>
</template>

<script>
import * as d3 from "d3";
import Header from "@/components/Header";
export default {
  data: function () {
    return {
      top20_data: null,
    };
  },
  components: {
    Header,
  },
  mounted: function () {
    if (!this.$store.state.top20_data) {
      d3.csv("top20.csv", (d) => {
        return {
          name: d.country,
          producing: +d.producing,
          user: +d.user,
        };
      }).then((data) => {
        this.top20_data = data;
        // console.log("chartData set from file");
        // console.log("chartData contains", this.chartData.length, "rows");
        this.$store.commit("top20_data", this.top20_data);
        this.top20();
      });
    } else {
      this.top20_data = this.$store.state.top20_data;
      //console.log("chartData set from store");
      //console.log("chartData contains", this.sunburst_data.length, "rows");
      this.top20();
    }
  },
  methods: {
    /* eslint-disable */
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    top20() {
      var xScale = d3
        .scaleBand() //🚧 use scale band for bar
        .round(true)
        .paddingInner(0.05);

      var yScale = d3.scaleLinear();

      var xAxis = d3
        .axisBottom() //🚧  set the position of xaxis
        .scale(xScale);

      var yAxis = d3.axisLeft().scale(yScale);

      //🚧  set the size of svg
      var data = this.top20_data;
      var margin = { top: 20, left: 100, bottom: 40, right: 40 };
      var width =
        parseInt(d3.select("#chart").style("width")) -
        margin.left -
        margin.right;
      var height =
        parseInt(d3.select("#chart").style("height")) -
        margin.top -
        margin.bottom;
      var svg = d3
        .select("#chart")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .append("g")
        .attr(
          "transform",
          "translate(" + margin.left + ", " + margin.top + ")"
        );

      xScale
        .domain(
          data.map(function (d) {
            //🚧  use d3.map to set the domain
            return d.name;
          })
        )
        .range([0, width]);

      yScale
        .domain([
          0,
          d3.max(data, function (d) {
            //🚧  use d3.max to set the domain
            return d.user;
          }),
        ])
        .range([height, 0])
        .nice();

      svg
        .append("g") //🚧  draw the xaxis
        .attr("class", "x axis")
        .attr("transform", "translate(0," + height + ")")
        .call(xAxis);

      svg
        .append("g") //🚧  draw the yaxis with its title
        .attr("class", "y axis")
        .call(yAxis)
        .append("text")
        .attr("transform", "rotate(-90)")
        .attr("y", 6)
        .attr("dy", ".7em");

      svg
        .selectAll(".bar") //🚧  draw the bar chart
        .data(data, function (d) {
          return d.name;
        })
        .enter()
        .append("rect") //ENTER
        .attr("class", "bar")
        .attr("x", function (d) {
          return xScale(d.name);
        })
        .attr("y", function (d) {
          return yScale(d.user);
        })
        .attr("width", xScale.bandwidth())
        .attr("height", function (d) {
          return height - yScale(d.user);
        })
        .attr("fill", "red");

      svg
        .selectAll(".bar2") //🚧  draw the bar chart
        .data(data, function (d) {
          return d.name;
        })
        .enter()
        .append("rect") //ENTER
        .attr("class", "bar2")
        .attr("x", function (d) {
          return xScale(d.name);
        })
        .attr("y", function (d) {
          return yScale(d.producing);
        })
        .attr("width", xScale.bandwidth())
        .attr("height", function (d) {
          return height - yScale(d.producing);
        })
        .attr("fill", "Orange");

      svg
        .selectAll(".name") //🚧  draw the xaxis parts of chart
        .data(data, function (d) {
          return d.name;
        })
        .enter() //ENTER
        .append("text")
        .text(function (d) {
          return d.name;
        })
        .attr("class", "name")
        .attr("x", function (d) {
          return xScale(d.name) + xScale.bandwidth() / 2;
        })
        .attr("y", function (d) {
          return height + 10;
        });

      svg
        .selectAll(".gravity") //🚧  draw the yaxis parts of chart
        .data(data, function (d) {
          return d.name;
        })
        .enter() //ENTER
        .append("text")
        .text(function (d) {
          return d.user;
        })
        .attr("class", "gravity")
        .attr("x", function (d) {
          return xScale(d.name) + xScale.bandwidth() / 2;
        })
        .attr("y", function (d) {
          return height + 20;
        })
        .append("tspan")
        // .text("-2")
        .style("baseline-shift", "super")
        .style("font-size", "0.7em");

      resize(); //🚧  because we can resize the windowthe chart changes

      //bind window resize event to call resize()
      d3.select(window).on("resize", resize); //🚧 set the resize function

      function resize() {
        var svg = d3.select("#chart");

        //🚧  size the bar chart
        width = parseInt(svg.style("width")) - margin.left - margin.right;
        height = parseInt(svg.style("height")) - margin.top - margin.bottom;
        svg.attr("width", width).attr("height", height);

        //🚧  set the range of xaxis and yaxis
        xScale.range([0, width]);
        yScale.range([height, 0]).nice();

        //🚧  set the xaxis part of bar chart when using resize function
        svg
          .selectAll(".bar")
          .data(data, function (d) {
            return d.name;
          }) //UPDATE
          .attr("x", function (d) {
            return xScale(d.name);
          })
          .attr("y", function (d) {
            return yScale(d.user);
          })
          .attr("width", xScale.bandwidth())
          .attr("height", function (d) {
            return height - yScale(d.user);
          });

        svg
          .selectAll(".bar2")
          .data(data, function (d) {
            return d.name;
          }) //UPDATE
          .attr("x", function (d) {
            return xScale(d.name);
          })
          .attr("y", function (d) {
            return yScale(d.producing);
          })
          .attr("width", xScale.bandwidth())
          .attr("height", function (d) {
            return height - yScale(d.producing);
          });

        if (width < 550 || height < 90) {
          //🚧  under some condition, set the xaxis and yxais not show
          svg.select(".x.axis").style("display", "none");
          svg.select(".y.axis").style("display", "none");

          //🚧  set the xaxis part of bar chart(initial reset to the element's default display value)
          svg
            .selectAll(".name")
            .data(data, function (d) {
              return d.name;
            }) //UPDATE
            .attr("x", function (d) {
              return xScale(d.name) + xScale.bandwidth() / 2;
            })
            .attr("y", function (d) {
              return height + 10;
            })
            .style("display", "initial");

          //🚧  set the yaxis part of bar chart(to making the axes visible)
          svg
            .selectAll(".gravity")
            .data(data, function (d) {
              return d.name;
            }) //UPDATE
            .attr("x", function (d) {
              return xScale(d.name) + xScale.bandwidth() / 2;
            })
            .attr("y", function (d) {
              return height + 20;
            })
            .style("display", "initial");

          //🚧  set the axis not show, but bar chart still show
          svg.select(".x.axis").style("display", "none");
          svg.select(".y.axis").style("display", "none");
          svg.selectAll(".name").style("display", "initial");
          svg.selectAll(".gravity").style("display", "initial");
        } else {
          //🚧  eset the ticks of axis
          yAxis.ticks(Math.max(height / 50, 2)); //one every 50 pixels
          xAxis.ticks(Math.max(width / 50, 2));

          //🚧  draw the xaxis
          svg
            .select(".x.axis")
            .attr("transform", "translate(0," + height + ")")
            .call(xAxis);

          svg.select(".y.axis").call(yAxis);

          //🚧  set the axis show, the bar chart not show
          svg.select(".x.axis").style("display", "initial");
          svg.select(".y.axis").style("display", "initial");
          svg.selectAll(".name").style("display", "none");
          svg.selectAll(".gravity").style("display", "none");
        }
      }
    },
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  align-items: center;
  /* text-align: center; */
  margin-left: 7%;
  margin-right: 7%;
}
.logo {
  margin-top: 80px;
  margin-left: 50px;
}
.Intro_container {
  color: powderblue;
  font-size: 25px;
  width: 100%;
  border-radius: 15px;
  background: #272727;
  padding: 2px;
  margin-top: 20px;
  margin-left: 50px;

  /* top: 200px; */
}
.Intro {
  margin-left: 10px;
  margin-bottom: 10px;
}
.legend {
  /* margin-top:-20px; */
  margin-left: 10px;
  margin-bottom: 10px;
}
.split {
  width: 420px;
  height: 0.1px;
  background: rgb(255, 255, 255, 0.3);
  margin-left: 10px;
  margin-top: -7px;
  margin-bottom: 8px;
}
.title {
  color: rgba(255, 255, 255, 0.781);
  font-size: 25px;
  margin-top: -40px;
  margin-left: 115px;
}
>>> .axis path,
>>> .axis line {
  shape-rendering: crispEdges;
  fill: white;
}

>>> .axis text {
  fill: white;
}

>>> text.name,
>>> text.gravity {
  text-anchor: middle;
  fill: white;
  font-size: 0.5em;
}

>>> #chart {
  width: 100%;
  height: 360px;
  background-color: #272727;
  border-radius: 15px;
}
body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  background: #121212;
  height: 100vh;
}
.next
{
  margin-top: 2%;
  margin-left: 50%;
}
</style>